import api from '@/services/apiService';
import {
  LoyaltyProgram,
  LoyaltySummaryResponse,
  LoyaltyParticipantsResponse,
  AddMemberPayload,
  ManualAdjustmentPayload,
} from '@/types/loyalty';

class LoyaltyService {
  async getProgram(arenaSlug: string): Promise<LoyaltyProgram> {
    const res = await api.get<{ data: LoyaltyProgram }>(`/arenas/${arenaSlug}/loyalty`);
    return res.data.data;
  }

  async updateProgram(arenaSlug: string, payload: Partial<LoyaltyProgram>): Promise<LoyaltyProgram> {
    const res = await api.put<{ data: LoyaltyProgram }>(`/arenas/${arenaSlug}/loyalty`, payload);
    return res.data.data;
  }

  async getSummary(arenaSlug: string): Promise<LoyaltySummaryResponse> {
    const res = await api.get<{ data: LoyaltySummaryResponse }>(`/arenas/${arenaSlug}/loyalty/summary`);
    return res.data.data;
  }

  async getParticipants(
    arenaSlug: string,
    params?: {
      page?: number;
      limit?: number;
      search?: string;
    }
  ): Promise<LoyaltyParticipantsResponse> {
    const res = await api.get<{ data: LoyaltyParticipantsResponse }>(
      `/arenas/${arenaSlug}/loyalty/participants`,
      { params }
    );
    return res.data.data;
  }

  async addMember(arenaSlug: string, payload: AddMemberPayload): Promise<any> {
    const res = await api.post<{ data: any }>(`/arenas/${arenaSlug}/loyalty/members`, payload);
    return res.data.data;
  }

  async manualAdjustment(arenaSlug: string, payload: ManualAdjustmentPayload): Promise<any> {
    const res = await api.post<{ data: any }>(`/arenas/${arenaSlug}/loyalty/adjust`, payload);
    return res.data.data;
  }
}

export const loyaltyService = new LoyaltyService();
export default loyaltyService;
